import { Stack, Text, ThemeIcon } from "@mantine/core";
import type { ReactNode } from "react";

interface Props {
  title: string;
  body?: string;
  icon?: ReactNode;
}

export function EmptyState({ title, body, icon }: Props) {
  return (
    <Stack align="center" gap="xs" py="xl">
      {icon && (
        <ThemeIcon size={56} radius="xl" variant="light" color="indigo">
          {icon}
        </ThemeIcon>
      )}
      <Text fw={600} size="lg">
        {title}
      </Text>
      {body && (
        <Text size="sm" c="dimmed" maw={420} ta="center">
          {body}
        </Text>
      )}
    </Stack>
  );
}
